import { createOrUpdateProductLineContacts } from 'src/graphql/mutations';
import { listProductLineContacts } from '../../graphql/queries';
import { FinanceContacts } from '../../types/contacts/contacts.types';
import { formatApiError } from '../../utils/errorUtils';
import { logger } from '../../utils/logger';
import { fetchGraphQLRequest } from './clients/graphqlClient';

export const fetchFinanceContactsAPI = async (): Promise<FinanceContacts[]> => {
  try {
    logger.info('Fetching finance contacts from GraphQL API');

    const result = await fetchGraphQLRequest<{ listProductLineContacts: FinanceContacts[] }>({
      query: listProductLineContacts,
      variables: {},
      requestName: 'listProductLineContacts',
      requestType: 'query',
    });

    const productLineContacts = result.listProductLineContacts || [];
    logger.info(`Fetched ${productLineContacts.length} finance contacts from API`);
    return productLineContacts;
  } catch (error) {
    logger.error('Error fetching finance contacts from GraphQL API:', { error });
    throw formatApiError('Failed to fetch finance contacts', error);
  }
};

export const updateFinanceContactsAPI = async (
  mutationData: FinanceContacts
): Promise<{ success: boolean; message: string }> => {
  try {
    logger.info(`Updating Finance contacts to GraphQL API: ${mutationData}`, mutationData);

    const mutationInput = {
      product_line_id: mutationData.product_line_id,
      pl_admins: mutationData.pl_admins,
      pl_escalation_managers: mutationData.pl_escalation_managers,
      asin_owners: mutationData.asin_owners,
      item_metadata: mutationData.item_metadata,
    };

    const result = await fetchGraphQLRequest<{ createOrUpdateProductLineContacts: { numberOfRecordsUpdated: number } }>(
      {
        query: createOrUpdateProductLineContacts,
        variables: { input: mutationInput },
        requestName: 'createOrUpdateProductLineContacts',
        requestType: 'mutation',
        auditConfig: { pageName: 'product_line_contacts' },
      }
    );

    const numberOfRecordsUpdated = result.createOrUpdateProductLineContacts.numberOfRecordsUpdated || 0;
    logger.info(`Finance Contacts updated successfully`, { numberOfRecordsUpdated });
    return {
      success: numberOfRecordsUpdated > 0,
      message: `Finance Contacts updated successfully (${numberOfRecordsUpdated} records updated)`,
    };
  } catch (error) {
    logger.error('Error updating contacts from GraphQL API:', { error });
    throw formatApiError('Failed to update contacts', error);
  }
};
